import { useStoryMeta } from "./useStoryMeta";
import type { ShareStoryOwner } from "../components/organisms/ShareStoryModal/ShareStoryModal.types";

/**
 * Who created the story, for the Share dialog's owner row. Read from the story row's `creator`
 * (the shared `storyMeta.detail` cache entry); undefined while it loads or when the API sends none.
 * The email stands in for a designation, which the API does not carry.
 */
export const useStoryOwner = (
  workspaceId: string | undefined,
  storyId: string | undefined,
): ShareStoryOwner | undefined => {
  const { storyMeta } = useStoryMeta(workspaceId, storyId);
  const creator = storyMeta?.creator;
  if (!creator?.name) return undefined;
  return { id: creator.id, name: creator.name, designation: creator.email ?? null };
};
